import React from "react";

//Assets
import logo from "../../assets/logo-w.png";

export default function Cover(props) {
  const { title } = props;
  return (
    <div className="coverImg">
      <img src={logo} alt="Cover" />
      <div className={"coverTitle"}>
        <h1>Welcome to</h1>
        <h2>{title}</h2>
      </div>
      <div className="cover" />
    </div>
  );
}
